import { Button, Accordion } from "web/components"

import { Task } from "web/components"

import { sortByKey } from "web/services/helpers"

import useCurrentStageIncompleteTasks from "../hooks/useCurrentStageIncompleteTasks"

const unscheduledTaskFilter = (task) =>
  !task.effective_due_date && task.due_date_required

export default function UnscheduledTasksWidget({ isOpen, onToggle }) {
  const { tasks, workflow } = useCurrentStageIncompleteTasks()

  const unscheduledTasks = tasks.filter(unscheduledTaskFilter)

  const sortedTasks = sortByKey(unscheduledTasks, "title")

  const numberOfTasks = sortedTasks.length
  const hasTasks = numberOfTasks > 0

  function goToTasks() {
    window.Turbo.visit(`${window.location.pathname}/workflow`)
  }

  const hasAdditionalTasks = sortedTasks.length > 5
  const numberOfAdditionalTasks = sortedTasks.length - 5

  return (
    <Accordion
      title="Tasks to Schedule"
      isOpen={isOpen}
      onToggle={onToggle}
      notificationCount={numberOfTasks}
    >
      <div>
        {hasTasks && (
          <div className="mb-3">
            {sortedTasks.slice(0, 5).map((task) => (
              <Task key={task.id} workflow={workflow} task={task} />
            ))}
          </div>
        )}
        {!hasTasks && (
          <div className="grid place-items-center py-2 text-sm italic text-neutral-4">
            No unscheduled tasks.
          </div>
        )}
        <div className="mt-4 flex items-center justify-between">
          <span className="text-sm text-neutral-4">
            {hasAdditionalTasks && `And ${numberOfAdditionalTasks} more...`}
          </span>
          <Button variant="secondary_default" size="small" onClick={goToTasks}>
            All Tasks
          </Button>
        </div>
      </div>
    </Accordion>
  )
}
